import { Navigate, Outlet } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { AuthGuard } from "./components/AuthGuard";
import { env } from "../../config/env";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const SignupPage = lazy(() => import("./pages/SignupPage"));

const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="flex h-[50vh] w-full items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>}>
    {children}
  </Suspense>
);

export const authRoutes: RouteObject[] = [
  {
    path: "auth",
    element: (
      <GoogleOAuthProvider clientId={env.googleClientId}>
        <AuthGuard>
          <Outlet />
        </AuthGuard>
      </GoogleOAuthProvider>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/auth/login" replace />,
      },
      {
        path: "login",
        element: (
          <SuspenseWrapper>
            <LoginPage />
          </SuspenseWrapper>
        ),
      },
      {
        path: "signup",
        element: (
          <SuspenseWrapper>
            <SignupPage />
          </SuspenseWrapper>
        ),
      },
    ],
  },
];
